export class LocationTypes{
    constructor(
        public ID: number,
        public Name: string,
        public IsDeleted: boolean,
        ){}
}